import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://amfwyenwasrzeruwksvr.supabase.co';
// Anon key — safe to expose, but prefer env vars. Rotate if compromised.
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY || 'sb_publishable_QRKI0Jaj4h2xomtBcFO8_w_D-Zvyy8Q';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
export { SUPABASE_URL, SUPABASE_KEY };

export const OTP_FUNCTION_URL = `${SUPABASE_URL}/functions/v1/send-otp`;